export default __webpack_public_path__ + "static/media/img6.1bc683db.png";